module.exports = __webpack_public_path__ + "img/change-pin.f9493354.svg";